module.exports = __webpack_public_path__ + "static/media/medical-history.7eeb71b7.svg";